import { render, staticRenderFns } from "./ShippingCompaniesCreate.vue?vue&type=template&id=86c7382a&"
import script from "./ShippingCompaniesCreate.vue?vue&type=script&lang=ts&"
export * from "./ShippingCompaniesCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports